/**
 * Redux actions for the AXIS compose url
 * @module redux/actions/axisDeficientAssetUrl
 */

import { createAction } from 'redux-actions';
import { createAxisDeficientAsset as apiCreateAxisDeficientAsset } from '../api/axis';
import { makeGetReplaceable } from '../selectors/asset';

export const CLEAR_URL = 'AXIS_DEFICIENT_ASSET/CLEAR_URL';
export const REQUEST_URL = 'AXIS_DEFICIENT_ASSET/REQUEST_URL';
export const REQUEST_URL_FAILED = 'AXIS_DEFICIENT_ASSET/REQUEST_URL_FAILED';
export const CREATED_DEFICIENT_ASSET = 'AXIS_DEFICIENT_ASSET/CREATED_DEFICIENT_ASSET';

export const clearAxisDeficientAssetUrl = () => (dispatch) => {
  dispatch(createAction(CLEAR_URL));
};

const axisDeficientAssetCreated = (replaceable, assetId, axisId, url) =>
  createAction(CREATED_DEFICIENT_ASSET)({
    assetId,
    axisId,
    replaceable,
    url
  });

const getAxisService = (selectedReplaceable) => {
  let axisService = selectedReplaceable.properties.axisService;
  if (!axisService) {
    axisService = selectedReplaceable.properties['axis product'];
  }

  return axisService;
};

const getAxisProject = (selectedReplaceable) => {
  let axisProject = selectedReplaceable.properties.axisProject;
  if (!axisProject) {
    axisProject = selectedReplaceable.properties['axis project'];
  }

  return axisProject;
};

const getAxisValue = (selectedReplaceable) => {
  let axisValue = selectedReplaceable.properties.axisStyle;
  if (!axisValue) {
    axisValue = selectedReplaceable.properties.axisTemplate;
  }
  if (!axisValue) {
    axisValue = selectedReplaceable.properties['axis template id'];
  }

  return axisValue;
};

export const createAxisDeficientAsset = (replaceable) => (dispatch, getState) => {
  dispatch(createAction(REQUEST_URL)());
  const getReplaceable = makeGetReplaceable();
  const state = getState();
  const user = state.info.username;
  const contextId = state.content.contextId;
  const selectedReplaceable = getReplaceable(state, state.asset.selectedReplaceableId);
  const axisService = getAxisService(selectedReplaceable);
  apiCreateAxisDeficientAsset(
    user, contextId, axisService, selectedReplaceable.type, selectedReplaceable.name)
    .then(response => {
      let fl = state.info.luciVersion;
      fl = fl.substring(0, fl.lastIndexOf('.'));
      const url = `${response.url}&Type=${axisService}&projectId=${getAxisProject(selectedReplaceable)}&templateId=${getAxisValue(selectedReplaceable)}&workflow=1&fl=${fl}&nver=2`;
      return dispatch(
        axisDeficientAssetCreated(replaceable, response.deficientAssetId, response.axisId, url));
    })
    .catch(error => {
      console.log(error);
      return dispatch(createAction(REQUEST_URL_FAILED)());
    });
};

export const actions = {
  clearAxisDeficientAssetUrl,
  createAxisDeficientAsset
};



// WEBPACK FOOTER //
// ./app/actions/axisDeficientAssetUrl.js